// extracted by mini-css-extract-plugin
export default {"tabLayout":"TabLayout_tabLayout__JM5VK","tabMenuContainer":"TabLayout_tabMenuContainer__0FgHd"};